<mat-accordion>
    <mat-expansion-panel *ngFor="let approval of buySellPlanApprovals" [matBadge]="approval.orderNumber" matBadgeSize="large" matBadgePosition="before" [expanded]="approval.comments !== null && approval.comments !== ''">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <app-employee-label [employee]="approval.reviewer"></app-employee-label>
            </mat-panel-title>

            <mat-panel-description>
                <mat-chip-list *ngIf="approval.status?.id !== 'COMPLETE'">
                    <mat-chip [ngClass]="getStatusChipClass(approval?.status?.id)">
                    {{ approval.status?.text }}
                    </mat-chip>
                </mat-chip-list>

                <mat-chip-list *ngIf="approval.isApproved !== null">
                    <mat-chip [ngClass]="approval.isApproved ? 'green-chip' : 'red-chip'">
                        {{ approval.isApproved ? 'Approved' : 'Denied' }}
                    </mat-chip>
                </mat-chip-list>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="approval-comments">
            <strong>Comments:</strong>
            <p>{{ approval.comments !== null ? approval.comments : 'No comments available' }}</p>
        </div>
    </mat-expansion-panel>
</mat-accordion>